/**
 * Where Beu Messages gets its data. One adapter per signed-in salon user.
 *
 * The contract every adapter meets (the stand-in in mockAdapter.js, and the
 * real one the backend brief asks for):
 *
 *   me()                                   -> { id, salonId, name }
 *   bootstrap()                            -> { me, people, conversations, messages, reminders, saved, tickets }
 *   send(conversationId, draft)            -> Message   draft: { text, attachments, card, replyToId, threadRootId, deliverAt, note, context }
 *   react(conversationId, messageId, emoji)-> Message   toggles my reaction
 *   edit(conversationId, messageId, text)  -> Message
 *   remove(conversationId, messageId, { moderate }) -> Message   soft delete ("Message removed"); moderate = a manager removing someone else's
 *   markRead(conversationId, atISO)        -> void
 *   setTyping(conversationId, on)          -> void
 *   updateConversation(id, { pinned, muted, topic, name, postBy }) -> Conversation
 *   createChat({ kind, name, topic, memberIds, postBy }) -> Conversation   createdBy, everyone (no memberIds) set by the server
 *   openDm(personId)                       -> Conversation (existing or new)
 *   assign(conversationId, staffId)        -> Conversation   client chats
 *   takeOver(conversationId) / handBack(conversationId) -> Conversation   Bailey in a client chat:
 *       conversation.bailey { state: 'replying' | 'needs-you' | 'paused', takenBy, since };
 *       sending in a chat Bailey is answering takes it over (one client inbox, brief section 27)
 *   resendAuto(conversationId, messageId, channel) -> Message
 *   remind / updateReminder / toggleSaved  -> reminders and Saved
 *   supportFeedback(messageId, helped)     -> void      Beu Support: "Did that sort it?"
 *   talkToTeam()                           -> Ticket    hands the support chat to the Beu team
 *   urgentHelp(context)                    -> Message   straight to the team, priority Urgent
 *   rateTicket(messageId, 'good' | 'bad')  -> void      bad reopens the ticket
 *   subscribe(fn)                          -> unsubscribe
 *       events: { type: 'message', message } | { type: 'message-updated', message }
 *               { type: 'conversation', conversation } | { type: 'read', conversationId, userId, at }
 *               { type: 'typing', conversationId, userId, on } | { type: 'reminder', reminder }
 *               { type: 'tickets', tickets } | { type: 'reset' }
 *   dispose()
 *
 * TO LAUNCH: return the real adapter here (socket + REST), keep the contract.
 */
import { createMockAdapter } from './mockAdapter';

export function createAdapter() {
    return createMockAdapter();
}

/** Who is signed in, read the way the rest of the app reads it. */
export function identityKey() {
    return `${localStorage.getItem('salonId') || ''}:${localStorage.getItem('userId') || ''}`;
}
